import moment from "moment"
import React, { useCallback, useMemo } from "react"

import Base from "../../../base"

const TimePicker = ({ disabled, withBorder = false, value, onChange }) => {
  const displayValue = useMemo(() => {
    return value ? moment(value).format("HH:mm") : ""
  }, [value])

  const onTimeChanged = useCallback(
    e => {
      const dateStr = e.target.value
      if (dateStr) {
        onChange(moment(dateStr, "HH:mm").toDate())
      }
    },
    [onChange],
  )

  const inputStyle = useMemo(
    () => ({
      height: 40,
      borderRadius: 20,
      flex: 1,
      justifyContent: "center",
      backgroundColor: "white",
      fontFamily: Base.fonts.appRegular,
      fontSize: 16,
      textAlign: "center",
      border: withBorder
        ? `1px solid ${Base.colours.appSemiLightGrey}`
        : "none",
    }),
    [withBorder],
  )

  return (
    <input
      type="time"
      style={inputStyle}
      value={displayValue}
      onChange={onTimeChanged}
      disabled={!!disabled}
    />
  )
}

export default TimePicker
